import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const ChevronRight: React.FC<IProps> = (props) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.8658 8.334C10.8658 7.86733 10.6858 7.40066 10.3325 7.04733L5.98582 2.70066C5.79249 2.50733 5.47249 2.50733 5.27916 2.70066C5.08582 2.894 5.08582 3.214 5.27916 3.40733L9.62582 7.754C9.94582 8.074 9.94582 8.594 9.62582 8.914L5.27915 13.2607C5.08582 13.454 5.08582 13.774 5.27915 13.9673C5.47249 14.1607 5.79249 14.1607 5.98582 13.9673L10.3325 9.62066C10.6858 9.26733 10.8658 8.80066 10.8658 8.334Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(ChevronRight);
